import { styled, css } from '../../theming';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { ExpandedState } from './types';
import { fallbackTheme } from '../../theming/fallbackTheme';

const navBarGateWrapperExpanded = css`
  overflow: scroll;
  flex-grow: 1;
  height: auto;
`;

const NavBarGateWrapper = styled.div<ExpandedState>`
  background: ${({ theme }) => fallbackTheme(theme).color.neutral.surfaceLightened};
  position: relative;
  ${({ isMobileMenuExpanded }) => isMobileMenuExpanded && navBarGateWrapperExpanded};

  @media (min-width: ${tokens.viewports.breakpoints.small}) {
    height: ${tokens.size.navBar.height};
    overflow: visible;
  }
`;

export default NavBarGateWrapper;
